// based on https://codepen.io/LoneFox/pen/OJVjPeg
export default class MultiSelect {
  constructor($select, options = {}) {
    if ($select === null) {
      throw "Empty select received";
    }
    this.$select = $select;
    this.options = this.validateOptions(options);

    this.setup();
    this.setupListeners();
  }

  validateOptions(options) {
    if (typeof options.caseSensitive === "undefined") {
      options.caseSensitive = false;
    }
    if (typeof options.limit === "undefined") {
      options.limit = 10;
    } else {
      options.limit = parseInt(options.limit);
    }

    return options;
  }

  setup() {
    this.buildContainer();
    let shown = 0;

    this.$select.querySelectorAll("option").forEach((option) => {
      if (option.selected) {
        this.addTag(option.innerText, option.value);
      } else if (shown < this.options.limit) {
        this.addOption(option.innerText, option.value);
        shown++;
      }
    });
  }

  setupListeners() {
    this.$container.querySelector("ul").addEventListener("click", (e) => {
      let li = e.target.closest("li");
      if (!li) {
        return;
      }
      this.selectOption(li);
    });

    this.$container.querySelector("div").addEventListener("click", (e) => {
      let a = e.target.closest("a");

      if (!a) {
        if (e.target.classList.contains("active")) {
          this.toggleContainerVisible();
        }
        return;
      }

      this.removeTag(a);
    });

    this.$container
      .querySelectorAll(
        ".selectMultiple > div .arrow, .selectMultiple > div span"
      )
      .forEach((el) => {
        el.addEventListener("click", (e) => {
          this.toggleContainerVisible();
        });
      });

    this.$input.addEventListener("input", (e) => {
      this.filterOptionsBy(this.$input.value);
    });

    // detect clicks outside the list, so we can decide whenever hide it
    document.addEventListener("click", (e) => {
      if (
        this.$container.classList.contains("open") &&
        !this.$container.contains(e.target) &&
        e.target != this.$select
      ) {
        this.setContainerVisible(false);
      }
    });
  }

  resetContainer() {
    this.$input.value = "";
    this.setContainerVisible(false);
    this.filterOptionsBy(""); // so all options are shown again if he clicks back
  }

  filterOptionsBy(query) {
    if (!this.options.caseSensitive) {
      query = query.toLowerCase();
    }

    this.removeAllOptions();
    let shown = 0;

    this.$select.querySelectorAll("option").forEach((option) => {
      if (option.selected) {
        return;
      }

      const text = !this.options.caseSensitive
        ? option.innerText.toLowerCase()
        : option.innerText;

      if (text.includes(query) && shown < this.options.limit) {
        this.addOption(option.innerText, option.value);
        shown++;
      }
    });
  }

  removeAllOptions() {
    this.$optionsList
      .querySelectorAll("li:not([data-search])")
      .forEach((option) => {
        option.remove();
      });
  }

  buildContainer() {
    const html = `
        <div class="selectMultiple ${this.options.className || ""}">
            <div data-tags-container class="active">
                <span data-placeholder></span>
                <div class="arrow"></div>
            </div>
            <ul>
                <li data-search>
                    <input type="text" placeholder="Search..." class="form-control">
                </li>
            </ul>
        </div>`;

    // main container
    const tmp = document.createElement("div");
    tmp.innerHTML = html;
    this.$container = tmp.firstElementChild;
    this.$select.parentElement.append(this.$container);

    this.$tagsContainer = this.$container.querySelector(
      "[data-tags-container]"
    );
    this.$placeholder = this.$container.querySelector("[data-placeholder]");
    this.$optionsList = this.$container.querySelector("ul");
    this.$input = this.$container.querySelector("input");

    if (typeof this.$select.dataset.placeholder !== "undefined") {
      this.$placeholder.innerText = this.$select.dataset.placeholder;
    }
  }

  addTag(text, value, animateAddition) {
    if (typeof animateAddition === "undefined") {
      animateAddition = false;
    }

    let tag = document.createElement("a");
    tag.dataset.value = value;
    tag.innerHTML = "<em>" + text + "</em><i></i>";

    this.$tagsContainer.appendChild(tag);
    this.$placeholder.classList.add("hide");

    this.$select
      .querySelector('option[value="' + value + '"]')
      .setAttribute("selected", "selected");

    if (animateAddition) {
      tag.classList.add("notShown");

      setTimeout(() => {
        tag.classList.add("shown");
      }, 300);
    }
    this.dispatchChangeEvent();
    return tag;
  }

  removeOption(li) {
    let styles = window.getComputedStyle(li);
    let liHeight = styles.height;
    let liPadding = styles.padding;
    let removing = li.animate(
      [
        {
          height: liHeight,
          padding: liPadding,
        },
        {
          height: "0px",
          padding: "0px",
        },
      ],
      {
        duration: 300,
        easing: "ease-in-out",
      }
    );

    removing.onfinish = () => {
      if (li.previousElementSibling) {
        li.previousElementSibling.classList.remove("beforeRemove");
      }
      if (li.nextElementSibling) {
        li.nextElementSibling.classList.remove("afterRemove");
      }
      li.remove();
      this.$container.classList.remove("clicked");
    };
  }

  addOption(text, value, animateAddition) {
    if (typeof animateAddition === "undefined") {
      animateAddition = false;
    }

    let item = document.createElement("li");
    item.dataset.value = value;
    item.innerHTML = text;
    this.$optionsList.appendChild(item);

    if (animateAddition) {
      item.classList.add("show");

      setTimeout(() => {
        if (this.$select.selectedOptions.length < 1) {
          this.$placeholder.classList.remove("hide");
        }
        item.classList.remove("show");
      }, 350);
    }
  }

  removeTag(tag) {
    tag.className = "";
    tag.classList.add("remove");
    //this.$container.classList.add('open');

    this.$select
      .querySelector('option[value="' + tag.dataset.value + '"]')
      .removeAttribute("selected");

    tag.classList.add("disappear");

    setTimeout(() => {
      // start animation
      let styles = window.getComputedStyle(tag);
      let padding = styles.padding;
      let deltaWidth = styles.width;
      let deltaHeight = styles.height;

      let removeOption = tag.animate(
        [
          {
            width: deltaWidth,
            height: deltaHeight,
            padding: padding,
          },
          {
            width: "0px",
            height: "0px",
            padding: "0px",
          },
        ],
        {
          duration: 0,
          easing: "ease-in-out",
        }
      );

      this.addOption(
        tag.querySelector("em").innerText,
        tag.dataset.value,
        true
      );

      removeOption.onfinish = () => {
        tag.remove();
      };
      this.dispatchChangeEvent();
    }, 300);
  }

  selectOption(li) {
    if (
      typeof li.dataset.search !== "undefined" ||
      this.$container.classList.contains("clicked")
    ) {
      return;
    }

    this.$container.classList.add("clicked");

    if (li.previousElementSibling) {
      li.previousElementSibling.classList.add("beforeRemove");
    }
    if (li.nextElementSibling) {
      li.nextElementSibling.classList.add("afterRemove");
    }
    li.classList.add("remove");

    this.addTag(li.innerText, li.dataset.value, true);

    setTimeout(() => {
      this.removeOption(li);
    }, 300);
  }

  setContainerVisible(enable) {
    if (enable) {
      this.$container.classList.add("open");
      this.focusInput();
    } else {
      this.$container.classList.remove("open");
    }
  }

  toggleContainerVisible() {
    this.$container.classList.toggle("open");
    this.focusInput();
  }

  focusInput() {
    // check if is hidden
    if (this.$input.offsetParent === null) {
      return;
    }
    this.$input.focus();
  }

  getSelectedOptions() {
    return Array.from(this.$select.selectedOptions).map(
      (option) => option.value
    );
  }

  dispatchChangeEvent() {
    this.$select.dispatchEvent(
      new CustomEvent("change", {
        detail: {
          options: this.getSelectedOptions(),
        },
      })
    );
  }
}

window.MultiSelect = MultiSelect;
